var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    viewBox: "0 0 100 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 68,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4947_5075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9064 70.5998C81.8991 74.393 78.278 77.6709 74.2069 80.289C72.918 81.1205 71.5814 81.8833 70.2039 82.5773C64.2575 85.5803 57.5472 87.2708 50.4415 87.2708C43.3357 87.2708 36.6255 85.5803 30.6791 82.5773C29.3016 81.8833 27.965 81.1205 26.6761 80.289C22.605 77.6709 18.9839 74.393 15.9766 70.5998C17.1154 66.5454 20.2796 63.3363 24.378 62.1956L31.0473 60.3402H31.0541L34.9684 59.2476L42.0878 57.2616L43.1721 51.132L43.6699 48.3283L43.7585 47.7992L44.2768 44.8924L50.4415 47.325L56.6062 44.8924L57.1244 47.7992L57.7109 51.132L58.236 54.1006L58.7952 57.2616L65.9146 59.2476L69.8289 60.3402H69.8357L76.505 62.1956C80.6034 63.3363 83.7676 66.5454 84.9064 70.5998Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9376 58.1668C68.5963 46.1721 50.4418 52.7958 50.4418 52.7958C50.4418 52.7958 32.2874 46.1721 30.946 58.1668C29.857 67.9096 50.4418 76.0747 50.4418 76.0747C50.4418 76.0747 71.0274 67.9096 69.9376 58.1668Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7972 57.2616C58.7972 61.8451 42.0898 61.8451 42.0898 57.2616L43.6719 48.3283L44.2789 44.8924L50.4435 47.325L56.6082 44.8924L58.238 54.1006L58.7972 57.2616Z",
    fill: "#F6B9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.238 54.1005C56.1854 54.7739 54.6374 54.7739 54.6374 54.7739C54.6374 54.7739 47.6203 54.7739 43.6719 48.3282L44.2788 44.8923L50.4435 47.3249L56.6082 44.8923L58.238 54.1005Z",
    fill: "#DB9A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9075 17.9228C62.3309 14.9432 59.3147 13.2946 56.5365 12.3827C52.584 11.0867 48.296 11.0867 44.3442 12.3827C41.5653 13.2946 38.5498 14.9432 36.9725 17.9228C34.122 23.4229 34.6075 31.9797 34.6075 31.9797L37.5794 35.1572L50.44 33.5128L63.3013 35.1572L66.2731 31.9797C66.2731 31.9797 66.758 23.4229 63.9075 17.9228Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3218 19.1482C59.3218 19.1482 64.4773 18.0789 63.8703 16.3218C63.2641 14.5647 61.9616 15.412 61.9616 15.412C61.9616 15.412 65.1592 13.571 63.1884 12.1197C62.0509 11.4106 60.535 12.1197 60.535 12.1197C60.535 12.1197 62.8092 9.52218 60.9142 8.52921C59.0184 7.53623 57.6538 8.835 57.6538 8.835C57.6538 8.835 57.9573 6.08491 55.9858 6.16119C54.015 6.23747 52.8776 9.14011 52.8776 9.14011C52.8776 9.14011 52.4186 6.84837 51.2457 6.92465C50.0728 7.00161 48.8596 9.29335 48.8596 9.29335C48.8596 9.29335 48.936 6.0052 47.0402 6.15913C45.1451 6.31374 44.3868 9.98053 44.3868 9.98053C44.3868 9.98053 43.428 7.38368 42.088 7.76507C40.748 8.14714 41.7334 11.4106 41.7334 11.4106C41.7334 11.4106 39.6869 9.59915 38.7772 10.7447C37.8668 11.8909 39.6869 13.2659 39.6869 13.2659C39.6869 13.2659 37.7155 12.6543 37.412 14.1064C37.1092 15.5577 40.092 18.002 42.088 18.6136L59.3218 19.1482Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0993 31.4611C67.0161 30.9128 66.815 30.3562 66.3997 29.9926C66.0253 29.6642 65.5097 29.5288 65.014 29.5501C64.5182 29.5714 64.0381 29.7384 63.5915 29.9562C63.5915 29.9562 63.5478 17.2881 59.0914 17.141C56.1686 16.9933 54.8688 17.877 50.441 17.877C46.0139 17.877 44.7135 16.9933 41.7914 17.141C37.335 17.2881 37.2913 29.9562 37.2913 29.9562C36.8447 29.7384 36.3646 29.5714 35.8688 29.5501C35.3724 29.5288 34.8575 29.6642 34.4831 29.9926C34.0671 30.3562 33.866 30.9128 33.7834 31.4611C33.6171 32.562 33.8782 33.722 34.4995 34.6421C35.1214 35.5629 36.0386 36.2549 37.1154 36.503C39.0152 49.9016 50.441 49.9016 50.441 49.9016C50.441 49.9016 61.8675 49.9016 63.7667 36.503C64.8435 36.2549 65.7614 35.5629 66.3826 34.6421C67.0045 33.722 67.2657 32.562 67.0993 31.4611Z",
    fill: "#F6B9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8008 29.7832V37.6453H51.1231C53.3898 37.6453 50.2215 30.6869 49.8008 29.7832Z",
    fill: "#DB9A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4136 26.7201C57.586 25.8102 55.5552 25.6749 53.6499 26.4383C52.8432 26.762 53.1944 28.0917 54.0127 27.7639C55.573 27.1386 57.2082 27.1516 58.7255 27.9068C59.5111 28.2978 60.2019 27.1124 59.4136 26.7201Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7715 29.7833C57.7715 30.4994 57.1959 31.0793 56.4853 31.0793C55.7748 31.0793 55.1992 30.4994 55.1992 29.7833C55.1992 29.0673 55.7748 28.4873 56.4853 28.4873C57.1959 28.4873 57.7715 29.0673 57.7715 29.7833Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.471 26.7201C43.2986 25.8102 45.3301 25.6749 47.2347 26.4383C48.0414 26.762 47.6902 28.0917 46.8719 27.7639C45.3117 27.1386 43.6764 27.1516 42.1591 27.9068C41.3735 28.2978 40.6827 27.1124 41.471 26.7201Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1152 29.7833C43.1152 30.4994 43.6908 31.0793 44.4014 31.0793C45.1119 31.0793 45.6875 30.4994 45.6875 29.7833C45.6875 29.0673 45.1119 28.4873 44.4014 28.4873C43.6908 28.4873 43.1152 29.0673 43.1152 29.7833Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.252 40.8568C46.7054 42.5624 48.4069 43.8323 50.4431 43.8323C52.4787 43.8323 54.1801 42.5624 54.6336 40.8568H46.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 42.7461,
    width: 67,
    height: 25.2538,
    fill: "url(#paint0_linear_4947_5075)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4947_5075",
    x1: 50.5,
    y1: 42.7461,
    x2: 50.5,
    y2: 67.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4947_5075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white",
    transform: "translate(17 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFace);
export default __webpack_public_path__ + "static/media/defaultFace.05e9a3aba416ecfdedb9e5e7da3dc42f.svg";
export { ForwardRef as ReactComponent };